<template>
  <Popconfirm v-bind="{ ...props }" :getPopupContainer="getPopupContainer">
    <slot></slot>
    <template v-for="(slot, name) in $slots" #[name]="slotData">
      <slot v-if="slot" :name="name" v-bind="slotData"></slot>
    </template>
  </Popconfirm>
</template>

<script lang="ts" setup>
import { Popconfirm } from 'ant-design-vue';
import { popconfirmProps } from 'ant-design-vue/es/popconfirm';

const props = defineProps({
  ...popconfirmProps(),
  containerId: {
    type: String,
  }
});

const getPopupContainer = function (triggerNode: HTMLElement) {
  const targetContainer = document.getElementById("render-control-panel")
  if (targetContainer) {
    return targetContainer
  } else {
    return document.body
  }
}

</script>
